/* unplugin-vue-components disabled */import { render } from "./main-modal.vue?vue&type=template&id=381265eb"
import script from "./main-modal.vue?vue&type=script&lang=js"
export * from "./main-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__